<template>
  <div id="app">
	<main id="main">
		<router-view :key="$route.fullPath"></router-view>
	</main>
  </div>
</template>

<script>
import Vue from 'vue';
import VueRouter from 'vue-router';
	
Vue.use(VueRouter);

export default {
  name: 'App'
}
</script>
